import { ACC_ENV_KEY, PROD_ENV_KEY, TEST_ENV_KEY, localeMapping, reqExpForReplaceNumbers, reqExpForReplaceProjectEnv, } from './constants';
export const getProjectKey = (value) => {
    const projectKey = value.toLowerCase();
    if (!projectKey.includes(ACC_ENV_KEY) && !projectKey.includes(TEST_ENV_KEY)) {
        return projectKey;
    }
    const projectKeySplitArr = projectKey.split('-');
    return projectKeySplitArr
        .map((item, index) => {
        if (projectKeySplitArr.length === index + 1) {
            return item.replace(reqExpForReplaceNumbers, '');
        }
        return item;
    })
        .join('-')
        .replace(reqExpForReplaceProjectEnv, PROD_ENV_KEY);
};
export const prepareLocale = (locale, projectKey) => {
    return localeMapping[projectKey] || locale.replace('EU', 'GB');
};
